import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { AuthenticationService } from '../services';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const authService = inject(AuthenticationService);
  const tokens = authService.restoreTokens();

  if (tokens?.accessToken) {
    const authRequest = request.clone({
      setHeaders: {
        Authorization: authService.authHeader({
          accessToken: tokens.accessToken,
          tokenType: tokens.tokenType,
        }),
      },
    });
    return next(authRequest);
  }

  return next(request);
};
